import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IDtpSearch, IDtpDetail, IDtpInsert, IDtpUpdate } from "./dtpTypes";



class DtpService {
    async page(searchVo: IDtpSearch, config: object = {}) {
        const apiUrl = "/gtm/customs/listPage";
        return await httpRequest.post<IPage<IDtpDetail>>(apiUrl, searchVo, config);
    }
    async insert(insertVo: IDtpInsert) {
        const apiUrl = "/gtm/customs/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IDtpUpdate) {
        const apiUrl = "/gtm/customs/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    async one(id: string) {
        const apiUrl = `/gtm/customs/findByIdOrCode/${id}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    //作废
    async disable(code: string) {
        const apiUrl = `/gtm/customs/disable/${code}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //转报价合同
    async transferQuottion(id: string) {
        const apiUrl = `/gtm/customs/transfer/${id}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }


    //列表导出
    async export(searchVo: IDtpSearch) {
        const appPageUrl = "/gtm/customs/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //明细导出
    async detailExport(code: string, shopCode: string) {
        const appPageUrl = `/gtm/customs/exportDetails/${code}/${shopCode}`;
        return await httpRequest.getFile(appPageUrl);
    }

    //询价单明细模板下载
    async downloadTpl() {
        const appPageUrl = "/gtm/customs/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

    // 总监审核
    async examineManager(Vo: {
        "code": string,  //"code"
        "status": "0" | "1",  // "0通过1驳回"
        "auditFlag": string, // "对错标识"
        "advise"?: string,  //"审批意见"
    }) {
        const apiUrl = "/gtm/customs/examineManager";
        return await httpRequest.post<boolean>(apiUrl, Vo);
    }
    //经理审核
    async examineReckoner(Vo: {
        "code": string,  //"code"
        "status": "0" | "1",  // "0通过1驳回"
        "auditFlag": string, // "对错标识"
        "advise"?: string,  //"审批意见"
    }) {
        const apiUrl = "/gtm/customs/manager";
        return await httpRequest.post<boolean>(apiUrl, Vo);
    }

    // 提交审核
    async submitCustoms(code: string) {
        const apiUrl = `/gtm/customs/submit/${code}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //单据生成
    async createBills(Vo: {
        "code": string,  //"code"
        "createBills": string,
    }) {
        const apiUrl = "/gtm/customs/createBills";
        return await httpRequest.post<boolean>(apiUrl, Vo);
    }

    //报关单转退税单
    async transferDrawback(Vo: {
        "code": string,  //"code"
        "shopCode": string,
    }) {
        const apiUrl = "/gtm/customs/transferDrawback";
        return await httpRequest.post<string>(apiUrl, Vo);
    }
    //查询外贸合同的件数和毛重
    async findBySaleCodeTotal(saleCode: string) {
        const apiUrl = `/gtm/shipment/findBySaleCodeTotal/${saleCode}`;
        return await httpRequest.get<any>(apiUrl);
    }
    //根据外贸合同查询出运单
    async findBySaleCode(saleCode: string) {
        const apiUrl = `/gtm/shipment/findBySaleCode/${saleCode}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    // 修改审批时间
    offerTime(updateVo: any){
        const apiUrl = `/gtm//audit/update`
        return   httpRequest.post<string>(apiUrl, updateVo);
    }
}

export const enquiryService = new DtpService();
